import angular from 'angular';
import { MeurhAlteracaoFotoService } from './alteracaofoto.service';

export const MeurhAlteracaoFotoListRouting = [
	'$stateProvider',
	function ($stateProvider: angular.ui.IStateProvider) {
        const resolve = {
            'entity': [
                'MeurhAlteracaoFotoService',
                '$rootScope',
                '$stateParams',
                '$state',
                '$q',
                function (
                    entityService: MeurhAlteracaoFotoService,
                    $rootScope: angular.IRootScopeService & {
                        session: any,
                        temPermissao: (arg: string) => boolean,
                        liberadoTela: (arg: string) => boolean,
                    },
                    $stateParams: angular.ui.IStateParamsService,
                    $state: angular.ui.IStateService,
                    $q: angular.IQService
                ) {
                    if (
                        !$rootScope.liberadoTela('LIBERAR_MEURH_SOLICITACAO_ALT_FOTO') ||
                        !$rootScope.temPermissao('visualizar_alteracaofoto')
                    ) {
                        return $q<void>(() => $state.go('dp'));
                    }

                    if (!$stateParams['solicitacao']) {
                        return $q<void>(() => $state.go('meurh_alteracaofoto'));
                    }

                    return entityService.get($stateParams['solicitacao'])
                        .then((data) => {
                            const deveRedirecionar = data.estabelecimento !== $rootScope.session.entities.estabelecimento.estabelecimento;
                            if (deveRedirecionar) {
                                return $q(() => $state.go('meurh_alteracaofoto'));
                            }

                            return data;
                        })
                        .catch((error) => {
                            if (error.status === 404) {
                                return $q(() => $state.go('not_found', $stateParams));
                            }

                            return $q.reject(error);
                        });
                }
            ]
        };

		$stateProvider
			.state('meurh_alteracaofoto', {
				url: '/solicitacoes/alteracaofoto',
				template: require('html-loader!./index/alteracaofoto.index.html'),
				controller: 'MeurhAlteracaoFotoIndexController',
				controllerAs: 'mrh_ltrcft_cntrllr'
			})
			.state('meurh_alteracaofoto_new', {
				url: '/solicitacoes/alteracaofoto/new',
				template: require('html-loader!./new/alteracaofoto.new.html'),
				controller: 'MeurhAlteracaoFotoNewController',
				controllerAs: 'mrh_ltrcft_nw_cntrllr',
			})
            .state('meurh_alteracaofoto_show', {
				url: '/solicitacoes/alteracaofoto/show/:solicitacao',
                resolve,
				template: require('html-loader!./show/alteracaofoto.show.html'),
				controller: 'MeurhAlteracaoFotoShowController',
				controllerAs: 'mrh_ltrcft_shw_cntrllr',
			});
	}
];
